
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Loader2 } from 'lucide-react';
import { ReviewReply } from '@/hooks/useReviewReplies';

interface ReviewReplyFormProps {
  reviewId: string;
  existingReply?: ReviewReply | null;
  businessName: string;
  onSubmit: (content: string) => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

const ReviewReplyForm: React.FC<ReviewReplyFormProps> = ({
  reviewId,
  existingReply,
  businessName,
  onSubmit,
  onCancel,
  isSubmitting
}) => {
  const [content, setContent] = useState(existingReply?.content || '');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (content.trim()) {
      onSubmit(content.trim());
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4 bg-muted/50 rounded-lg">
      <div>
        <Label htmlFor="business-name" className="text-sm font-medium">
          Replying as
        </Label>
        <div className="mt-1 p-2 bg-background rounded border text-sm font-medium">
          {businessName}
        </div>
      </div>

      <div>
        <Label htmlFor="reply-content" className="text-sm font-medium">
          Your Reply
        </Label>
        <Textarea
          id="reply-content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Write your reply to this review..."
          className="mt-1 min-h-[100px]"
          maxLength={1000}
        />
        <div className="text-xs text-muted-foreground mt-1">
          {content.length}/1000 characters
        </div>
      </div>

      <div className="flex gap-2 justify-end">
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          disabled={!content.trim() || isSubmitting}
        >
          {isSubmitting && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
          {existingReply ? 'Update Reply' : 'Submit Reply'}
        </Button>
      </div>
    </form>
  );
};

export default ReviewReplyForm;
